import { RbacRole } from '../../models/rbac';

export function toRbacRole(value: string): RbacRole {
    return value as RbacRole;
}
